import type { FunctionComponent } from "react";

import CardValue from "~/components/Card/components/CardValue.tsx";
import Headline from "~/components/Headline/Headline";
import type { EInvoiceTotals } from "~/modules/billing/api/eInvoice/eInvoiceTypes.ts";

import { formatEInvoiceCents, formatEInvoicePercent } from "../eInvoiceFormat.ts";

type Props = { totals: EInvoiceTotals };

const EInvoiceTotalsSection: FunctionComponent<Props> = ({ totals }) => (
	<div className="flex flex-col gap-3">
		<Headline type="h5">Beträge</Headline>
		<CardValue label="Nettobetrag">{formatEInvoiceCents(totals.taxBasisAmount)}</CardValue>
		<CardValue label="USt-Satz">{formatEInvoicePercent(totals.vatRate)}</CardValue>
		<CardValue label="USt-Kategorie">{totals.vatCategoryCode}</CardValue>
		<CardValue label="USt-Betrag">{formatEInvoiceCents(totals.vatAmount)}</CardValue>
		<CardValue label="Gesamtbetrag">{formatEInvoiceCents(totals.grandTotalAmount)}</CardValue>
		<CardValue label="Zahlbetrag">{formatEInvoiceCents(totals.duePayableAmount)}</CardValue>
	</div>
);

export default EInvoiceTotalsSection;
